import React, { useEffect, useId, useRef } from 'react'

type CheckboxProps = {
  id?: string
  label?: React.ReactNode
  ariaLabel?: string
  checked: boolean
  indeterminate?: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
  onClick?: React.MouseEventHandler<HTMLInputElement>
  wrapperClassName?: string
  inputClassName?: string
  labelClassName?: string
}

function Checkbox({
  id,
  label,
  ariaLabel,
  checked,
  indeterminate = false,
  onChange,
  onClick,
  wrapperClassName = '',
  inputClassName = '',
  labelClassName = '',
}: CheckboxProps) {
  const generatedId = useId()
  const inputId = id ?? generatedId
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  return (
    <div className={wrapperClassName}>
      <input
        id={inputId}
        ref={ref}
        type="checkbox"
        className={inputClassName}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
        aria-label={!label ? ariaLabel : undefined}
      />
      {label && <label htmlFor={inputId} className={labelClassName}>{label}</label>}
    </div>
  )
}

Checkbox.defaultProps = {
  id: undefined,
  label: undefined,
  onClick: undefined,
  indeterminate: false,
  ariaLabel: '',
  labelClassName: '',
  wrapperClassName: '',
  inputClassName: '',
}

export default Checkbox

